export default {
    encoding: [
        {
            name: 'fill',
            type: '[string]',
            desc: 'Specify the dataSource applied to the fill color.',
            isRequired: 'false',
        },
        {
            name: 'stroke',
            type: '[string]',
            desc: 'Specify the dataSource applied to the stroke color.',
            isRequired: 'false',
        },
    ],
    events: [
        {
            name: 'rectangle.click',
            desc: 'triggered when user clicks the ellipse',
        },
    ],
};
